<template>
    <el-dialog class="peiso-modal kseries-container"
    :visible.sync="isOpen"
    :modal-append-to-body="false"
    :close-on-click-modal='false'
    :close-on-press-escape="false"
    width="550px"
    :before-close="handleClose"
    center>

        <div v-if="isUploadingData" class="loading-container d-flex align-items-center justify-content-center w-100">
            <div class="loading-label-wrapper">
                <template  v-if="!retrievingRedcat">
                    <div v-if="!isDoneUploading" class="loading m-bottom-1rem text-center">
                        <i class="el-icon-loading"></i>
                    </div>
                    <span v-if="!isDoneUploading" class="text-center">
                        Uploading order data to the database.
                        <span class="d-block">Please wait...</span>
                    </span>
                    <span v-if="isDoneUploading" class="text-center">
                        Load Successfully
                        <span class="d-block">Order data successfully loaded</span>
                    </span>
                </template>
                <template v-else>
                    <div class="loading m-bottom-1rem text-center">
                        <i class="el-icon-loading"></i>
                    </div>
                    <span class="text-center">
                        {{ retrievingLabel }}
                        <span class="d-block">Please wait...</span>
                    </span>
                </template>
            </div>
        </div>

        <div class="header-container">
            <span>Select Site Location</span>
        </div>
        <div class="body-container">
            <div class="field-group">
                <div>
                    <el-select filterable v-model="siteValue" placeholder="Select a Site" class="peiso-select-default w-100 m-bottom-1rem" @change="handleChange">
                        <el-option v-for="(item, i) in orderBySiteLocation(siteLocation)" :key="`site-${i}`" :label="item.name" :value="item"></el-option>
                    </el-select>
                </div>

                <template v-if="isOpenTerminal">
                    <div class="header-container m-top-1rem m-bottom-1rem">
                        <span>Select Terminals</span>
                    </div>
                    <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
                    <div class="list-field-group" :class="{'d-flex align-items-center justify-content-center' : !terminals.length}">
                        <template v-if="terminals.length">
                            <div class="peiso-checkbox terminals checkbox-select-all mb-1" v-if="isPro">
                                <el-checkbox label="all" :disabled="!isPro" @change="checkedAllTerminal" :key="`checkbox-beverage-1111`"  v-model="isCheckedTerminal">{{ isCheckedTerminal ? 'Unselect All' : 'Select All' }}</el-checkbox>
                            </div>
                            <el-checkbox-group v-model="selectedTerminals" class="peiso-checkbox terminals" @change="handleSelectedTerminals">

                                <el-checkbox v-for="(item, i) in terminals" :key="`checkbox-${item.id}`" :label="item">{{ item.name }}</el-checkbox>
                            </el-checkbox-group>
                        </template>
                        <template v-else>
                            <span class="p-2">No terminals available for {{ selectedSite.name }}. <br /> Please click 'Next' to continue.</span>
                        </template>
                    </div>
                    <span v-if="!selectedTerminals.length" class="errortext m-top-1rem">If no terminal is selected, the orders will not be filtered</span>

                </template>
            </div>


            <template v-if="step == 1">
                <template v-if="registers.length">
                    <div class="header-container m-top-1rem m-bottom-1rem">
                        <span>Select Registers</span>
                    </div>
                    <span v-if="validationMessage"  class="errortext m-bottom-1rem">{{validationMessage}}</span>
                    <div class="list-field-group">
                        <div class="peiso-checkbox checkbox-select-all mb-1" v-if="isPro">
                            <el-checkbox label="all" :disabled="!isPro" @change="checkedAllRegister" :key="`checkbox-beverage-1111`"  v-model="isCheckedRegister">{{ isCheckedRegister ? 'Unselect All' : 'Select All' }}</el-checkbox>
                        </div>
                        <!-- <div v-for="(item, i) in registers" :key="`registers-${i}`" class="list-grp-container d-flex align-items-center justify-content-between cursor-pointer">
                            <div>
                                <span>{{ item.name }}</span>
                            </div>

                            <img v-if="!item.isSelected" width="20px" src="@/assets/circle.svg" alt="">
                            <img v-else width="20px" src="@/assets/selected.png" alt="">
                        </div>   -->
                        <!-- <el-checkbox v-model="isSelectAllRigesters">Select All</el-checkbox> -->

                        <el-checkbox-group v-model="selectedRegisters" class="peiso-checkbox" @change="handleSelected">

                            <el-checkbox v-for="(item, i) in registers" :key="`checkbox-${item.id}`" :label="item">{{ item.name }}</el-checkbox>
                        </el-checkbox-group>
                    </div>



                </template>
            </template>
            <template v-else-if="step == 2 && isPro">
                <template v-if="categories.length">
                    <div class="header-container m-top-1rem m-bottom-1rem">
                        <span>Select Foods</span>
                    </div>
                    <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
                    <div class="list-field-group">
                        <div class="peiso-checkbox checkbox-select-all mb-1" v-if="isPro">
                            <el-checkbox label="all" :disabled="!isPro" @change="checkedAllFood" :key="`checkbox-beverage-102`"  v-model="isCheckedFood">{{ isCheckedFood ? 'Unselect All' : 'Select All' }}</el-checkbox>
                        </div>
                        <el-checkbox-group v-model="checkedFood" class="peiso-checkbox" @change="handleSelectedFood">
                            <el-checkbox v-for="(item, i) in categories" :key="`checkbox-food-${item.id}`" :disabled="!isPro" :label="item">{{ item.name }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </template>
            </template>
            <template v-else-if="step == 3  && isPro">
                <template v-if="categories.length">
                    <div class="header-container m-top-1rem m-bottom-1rem">
                        <span>Select Beverages</span>
                    </div>
                    <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
                    <div class="list-field-group">
                        <div class="peiso-checkbox checkbox-select-all  mb-1" v-if="isPro">
                            <el-checkbox label="all" :key="`checkbox-beverage-101`" :disabled="!isPro" @change="checkedAllBeverage" v-model="isCheckedBeverage">{{ isCheckedBeverage ? 'Unselect All' : 'Select All' }}</el-checkbox>
                        </div>
                        <el-checkbox-group v-model="checkedBeverage" class="peiso-checkbox" @change="handleSelectedBeverage">
                            <el-checkbox v-for="(item, i) in categories" :key="`checkbox-beverage-${item.id}`" :disabled="!isPro"  :label="item">{{ item.name }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </template>
            </template>

            <template v-else-if="step == 4 && isPro">
                <template v-if="categories.length">
                    <div class="header-container m-top-1rem m-bottom-1rem">
                        <span>Select Revenue Group</span>
                    </div>
                    <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
                    <div class="list-field-group">
                        <el-checkbox-group :value="checkedRevenueGroup" class="peiso-checkbox">
                            <el-checkbox v-for="(item, i) in revenues"  @change="handleSelectedRevenue(item)" :key="`checkbox-revenue-${i}`" :label="item">{{ item }}</el-checkbox>
                        </el-checkbox-group>

                    </div>
                </template>
            </template>

            <template>
                <div class="d-flex gap-10 m-top-1rem" v-if="isPro && (step == 1 || step == 2 || step == 3)">
                    <el-button v-if="step != 1" type="peiso-default" class="w-100" @click="step--">Back</el-button>
                    <template v-if="integrationType == 'redcat'">
                        <el-button type="peiso-primary-pink" class="w-100" @click="next(step)" :disabled="this.selectedTerminals.length || integrationType == 'redcat' ? false : true">Next</el-button>
                    </template>
                    <template v-if="integrationType == 'oseries'">
                        <el-button type="peiso-primary-pink" class="w-100" @click="next(step)" :disabled="this.selectedRegisters.length || integrationType == 'redcat' ? false : true">Next</el-button>
                    </template>
                </div>
                <div v-else-if="step == 1 && !isPro" class="d-flex gap-10 m-top-1rem">
                    <!-- <el-button type="peiso-default" class="w-100" @click="step--">Back</el-button> -->
                    <el-button v-if="!isLoading" type="peiso-primary-pink" class="w-100" @click="confirmCompleteOseries" :disabled="!selectedRegisters.length ? true : false">Confirm</el-button>
                    <el-button v-if="isLoading" type="peiso-primary-pink" class="w-100"><i class="el-icon-loading"></i> Loading...</el-button>
                </div>
                <div v-else-if="step == 4 && isPro" class="d-flex gap-10 m-top-1rem">
                    <el-button type="peiso-default" class="w-100" @click="step--">Back</el-button>
                    <el-button v-if="!isLoading && integrationType != 'redcat'" type="peiso-primary-pink" class="w-100" @click="confirmCompleteOseries" :disabled="!selectedRegisters.length ? true : false">Confirm</el-button>
                    <el-button v-if="!isLoading && integrationType == 'redcat'" type="peiso-primary-pink" class="w-100" @click="confirmCompleteRedcat">Confirm Redcat</el-button>
                    <el-button v-if="isLoading" type="peiso-primary-pink" class="w-100"><i class="el-icon-loading"></i> Loading...</el-button>
                </div>
            </template>
        </div>

    </el-dialog>
</template>

<style lang='scss'>
@import '../../../static/scss/colors.scss';
@import '../../../static/scss/fonts/fonts.scss';
    .mb-1 {
        margin-bottom: 10px;
    }
    .p-2 {
      padding: 10px !important;
      text-align: center !important;
    }
    .errortext {
        color: #ff4c30 !important;
        font-size: 13px !important;
        margin-bottom: 10px !important;
    }
    .checkbox-select-all {
        position: sticky;
        left: 0;
        top: -12px;
        width: 100%;
        z-index: 50;
        background-color: var(--background-color-3);
        padding-top: 10px;
    }
    .kseries-container {
        .el-button--peiso-default {
            > span {
                width: 100%;
            }
        }

        .el-dialog__headerbtn {
            display: none;
        }

        .list-grp-container {
            padding: 1rem;
        }

        .field-group {
            span {
                @include montserrat-font(14px, normal, 500, $white) {
                    margin-bottom: 10px;
                }
            }
        }

        .list-field-group {
            position: relative;
            min-height: 200px;
            max-height: 400px;
            overflow: hidden auto;

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: #434968;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: #434968;
            }
            @include montserrat-font(14px, normal, 500, $white) {
                background-color: var(--background-color-3);
                padding: 10px;
            }
            .list-grp-container {

            }
        }

        .loading-container {
            position: absolute;
            left: 0px;
            top: 0px;
            height: 100%;
            background: var(--background-color-4);
            z-index: 60;
            border-radius: 10px;

            .loading-label-wrapper {
                padding: 2rem 2rem;
                box-shadow: 0 1px 3px rgba(0,0,0,.3);
                background-color: $gray2;

                @include montserrat-font(14px, normal, 500, $white);

                .loading {
                    font-size: 50px;
                }
            }
        }

        .terminals {
            .el-checkbox__inner {
                margin-bottom: 0px;
            }
        }
    }
</style>

<script>
    import utils from '../../utils/utils'
    import dashboard from '@/api/dashboard'
    import api from '../../api/api'
    export default {
        data() {
            return {
                siteLocation: [],
                categories: [],
                siteValue: null,
                selectedFood: [],
                checkedFood: [],
                selectedBeverage: [],
                checkedBeverage: [],
                isUploadingData: false,
                isDoneUploading: false,
                isLoadingRegisters: false,
                isOpen: false,
                registers: [],
                selectedRegisters: [],
                selectedTerminals: [],
                selectedSite: {},
                checkedRegisters: [],
                isLoading: false,
                step: 1,
                validationMessage: '',
                isCheckedFood: false,
                isCheckedBeverage: false,
                isCheckedTerminal: false,
                isCheckedRegister: false,
                checkedRevenueGroup: ['both'],
                isPro: false,
                revenueGroupId: 'both',
                revenues: [
                    'both',
                    'food',
                    'beverage'
                ],
                terminals: [],
                retrievingRedcat: false,
                retrievingLabel: '',
                isOpenTerminal: false,
            }
        },
        props: {
            open: {
                default: false
            },
            sites: {
                default: null
            },
            integrationType: {
                default: null
            }
        },
        watch: {
            open(val) {
                this.isOpen = val
            },
            sites(val) {
                this.siteLocation = val

            }
        },
        computed: {
        },
        methods: {
            orderBySiteLocation(siteLocation) {
              return _.orderBy(siteLocation, ['name'], ['asc']);
            },
            handleClose() {
                this.isOpen = false
                this.$emit('close-modal')
            },
            handleChange(e) {
                if (this.selectedSite && this.selectedSite.id != e.id){
                    this.checkedRegisters = [];
                    this.selectedFood = [];
                    this.selectedBeverage = [];
                    this.step = 1;
                }

                this.siteValue = e.name
                this.selectedSite = e
                this.isLoadingRegisters = true
                this.isOpenTerminal = false
                this.retrievingRedcat = false
                if (this.integrationType == 'oseries') {
                    api.oseriesRegisters({siteId: e.id}).then((res) => {
                        this.isLoadingRegisters = false
                        var result = res.data
                        this.registers = result.data
                        this.checkedRegisters = this.checkSelectAll(this.isPro, result.data)
                        console.log(this.checkedRegisters, 'this.checkedRegisters')
                        this.isSelectAllRigesters = this.setCheckAll(this.checkedRegisters.length, this.registers.length)
                    })

                    api.oseriesCategories({siteId: e.id}).then((res) => {
                        this.categories = res.data.data;
                        this.checkedBeverage = this.categories;
                        this.checkedFood = this.categories;
                        this.isCheckedBeverage = true;
                        this.isCheckedFood = true;
                    });
                } else if (this.integrationType == 'redcat') {
                    this.isOpenTerminal = false
                    this.isUploadingData = true
                    this.retrievingRedcat = true
                    this.retrievingLabel = 'Retrieving food and beverage category list.'
                    api.redcatGetCategories({siteId: e.id}).then((res) => {
                        var result = res.data
                        this.categories = result.data
                        this.checkedBeverage = this.categories;
                        this.checkedFood = this.categories;
                        this.isCheckedBeverage = true;
                        this.isCheckedFood = true;
                        this.retrievingLabel = 'Retrieving terminal list.'

                        this.step = 2;
                    })

                    api.redcatGetTerminals({siteId: e.id}).then((res) => {
                        var result = res.data
                        this.terminals = result.data
                        this.isCheckedTerminal = true
                        this.checkedAllTerminal()
                        this.retrievingLabel = ''
                        this.isUploadingData = false
                        this.retrievingRedcat = false

                        this.step = 2;
                    })
                }

            },

            handleSelected(e) {
                this.checkedRegisters = e
                this.isCheckedRegister = false;
            },
            handleSelectedTerminals(e) {
                this.selectedTerminals = e
                this.isCheckedTerminal = false
            },
            checkedAllRegister() {
                if (!this.isCheckedRegister) {
                    this.checkedRegisters = [];
                    this.selectedRegisters = [];
                } else {
                    this.selectedRegisters = this.registers;
                    this.checkedRegisters = this.registers;
                }
            },
            checkedAllTerminal() {
                if (!this.isCheckedTerminal) {
                    this.selectedTerminals = [];
                } else {
                    this.selectedTerminals = this.terminals;
                }
            },
            checkedAllFood() {
                // this.isCheckedFood = !this.isCheckedFood;
                if (!this.isCheckedFood) {
                    this.checkedFood = [];
                } else {
                    this.checkedFood = this.categories;
                }
            },
            checkedAllBeverage() {
                if (!this.isCheckedBeverage) {
                    this.checkedBeverage = [];
                } else {
                    this.checkedBeverage = this.categories;
                }
            },

            handleSelectedFood(e) {
                this.checkedFood = e
                this.isCheckedFood = false;
            },

            handleSelectedRevenue(item) {
                this.checkedRevenueGroup = [item]
                this.revenueGroupId = item;
            },

            handleSelectedBeverage(e) {
                this.checkedBeverage = e;
                this.isCheckedBeverage = false;
            },

            next(step) {
                if (step == 1 && this.checkedRegisters.length <= 0 && this.integrationType == 'oseries') {
                    this.validationMessage = 'Please select registers';
                } else if (step == 2 && this.checkedFood.length <= 0) {
                    this.validationMessage = 'Please select foods';
                } else if (step == 3 && this.checkedBeverage.length <= 0) {
                    this.validationMessage = 'Please select beverages';
                } else {
                    this.validationMessage = '';
                    this.step = (step + 1)
                    this.isOpenTerminal = false
                }

            },

            confirmCompleteOseries() {
                if (this.step == 3 && this.checkedBeverage.length <= 0) {
                    this.validationMessage = 'Please select beverages';
                    return;
                }

                var profitTarget = {
                    profitTarget: 1000,
                    profitTargetType: 0,
                    type: 0,
                    revenueTargetThreshold: 100
                }

                var data = {
                    siteId: this.selectedSite.id,
                    registers: this.checkedRegisters,
                    profitTarget: profitTarget,
                    foodCategories: this.checkedFood,
                    beverageCategories: this.checkedBeverage,
                    revenueGroupId: this.revenueGroupId
                }

                this.isUploadingData = true
                this.isDoneUploading = false
                this.isLoading = true
                this.retrievingRedcat = false

                api.oseriesComplete(data).then((res) => {
                    this.isDoneUploading = true
                    setTimeout(() => {
                        this.isUploadingData = false
                        this.isOpen = false
                        this.isLoading = false
                        this.$emit('oseriesFlagged')
                    }, 1000);
                }).catch(() => {
                    this.isOpen = false
                    this.$emit('oseriesFlagged')
                })
            },

            confirmCompleteRedcat() {
                if (this.checkedBeverage.length <= 0) {
                    this.validationMessage = 'Please select beverages';
                    return;
                } else if (this.checkedFood.length <= 0) {
                    this.validationMessage = 'Please select foods';
                    return;
                }

                var profitTarget = {
                    profitTarget: 1000,
                    profitTargetType: 0,
                    type: 0,
                    revenueTargetThreshold: 100
                }

                var data = {
                    siteId: this.selectedSite.id,
                    profitTarget: profitTarget,
                    foodCategories: this.checkedFood,
                    beverageCategories: this.checkedBeverage,
                    terminals: this.selectedTerminals,
                    revenueGroupId: this.revenueGroupId,
                }

                this.isUploadingData = true
                this.isDoneUploading = false
                this.isLoading = true
                this.retrievingRedcat = false

                api.redcatCompleteBinding(data).then((res) => {
                    this.isDoneUploading = true
                    setTimeout(() => {
                        this.isUploadingData = false
                        this.isOpen = false
                        this.isLoading = false
                        this.$emit('redcatFlagged')
                    }, 1000);
                }).catch(() => {
                    this.isOpen = false
                    this.$emit('redcatFlagged')
                })
            },

            handleSelectAllRigesters(isCheck) {
                console.log(isCheck)
                console.log(selectedRegisters, 'selectedRegisters')
                // if (!isCheck) {
                //     this.checkedRegisters = []
                // } else {
                //     this.checkedRegisters = this.registers
                // }
            },

            checkSelectAll(isPro, data) {
                var list = []
                if (isPro) {
                    list = data
                }

                return list
            },

            setCheckAll(data, item) {
                var check = data == item ? true : false
                return check
            }

        },
        mounted() {
            this.$root.$on('isPro', (isPro, other) => {
                this.isPro = isPro
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modal/siteRegisters.vue